import Vue from 'vue';
import Router from 'vue-router';
import Home from '../views/Home.vue';

Vue.use(Router);
export const routes = [{
        path: '/',
        redirect: '/login',
    },
    // {
    //     path: '/login',
    //     name: 'Login',
    //     component: () =>
    //         import('@views/Login/Login.vue')
    // },
    // 新的登录
    {
        path: '/login',
        name: 'Login',
        hidden: true,
        component: () =>
            import ('@views/Login/new-Login.vue')
    },
    {
        path: '/home',
        component: Home,
        meta: { title: '系统管理', icon: 'inbox' },
        hidden: false,
        children: [
            {
                path: '/home/system/menus',
                component: () =>
                    import ('@views/system/menus/menus'),
                meta: { title: '菜单管理', icon: '' },
                hidden: false,
            }, {
                path: '/home/system/user',
                component: () =>
                    import ('@views/system/user/user'),
                meta: { title: '用户管理', icon: '' },
                hidden: false,

            }, {
                path: '/home/system/role-manage/assignUsers',
                component: () =>
                    import ('@views/system/role-manage/assign-users'),
                meta: { title: '角色管理-分配用户', icon: '' },
                hidden: false,
            }, {
                path: '/home/system/role-manage',
                component: () =>
                    import ('@views/system/role-manage/role'),
                meta: { title: '角色管理', icon: '' },
                hidden: false,
            }, {
                path: '/home/user/assignRoles',
                component: () =>
                    import ('@views/system/user/assign-roles'),
                meta: { title: '用户管理-分配角色', icon: '' },
                hidden: false,
            },
            {
                path: '/home/system/dictionary',
                component: () =>
                    import ('@views/system/dictionary'),
                meta: { title: '字典管理', icon: '' },
                hidden: false,
            },
            {
                path: '/home/system/allocation',
                component: () =>
                    import ('@views/system/allocation'),
                meta: { title: '字典分配', icon: '' },
                hidden: false,
            },
            {
                path: '/home/system/department',
                component: () =>
                    import ('@views/system/department'),
                meta: { title: '部门管理', icon: '' },
                hidden: false,
            },
            {
                path: '/home/system/role-manage/role-allocation',
                component: () =>
                    import ('@views/system/role-manage/role-allocation'),
                meta: { title: '分配菜单', icon: '' },
                hidden: false,
            },
            {
                path: '/home/package/picture',
                component: () =>
                    import ('@views/package/picture'),
                meta: { title: '轮播图管理', icon: ' ' },
                hidden: false,
            },

            //陪诊系统
            //首页
            {
                path: '/home/home-page/home-page',
                component: () =>
                    import ('@views/home-page/home-page'),
                meta: { title: '首页', icon: '' },
                hidden: false,
            },
            //服务管理-客户服务
            {
                path: '/home/service-management/customer-service/customer-service',
                component: () =>
                    import ('@views/service-management/customer-service/customer-service'),
                meta: { title: '客户服务', icon: '' },
                hidden: false,
            },
            //服务管理-客户服务-交付页面
            {
                path: '/home/service-management/customer-service/pages/add-bank',
                component: () =>
                    import ('@views/service-management/customer-service/pages/add-bank.vue'),
                meta: { title: '客户服务', icon: '' },
                hidden: false,
            },
            //服务管理-服务评价
            {
                path: '/home/service-management/service-evaluation/service-evaluation',
                component: () =>
                    import ('@views/service-management/service-evaluation/service-evaluation'),
                meta: { title: '服务评价', icon: '' },
                hidden: false,
            },
            //服务管理-服务评价-详情
            {
                path: '/home/service-management/service-evaluation/pages/details',
                component: () =>
                    import ('@views/service-management/service-evaluation/pages/details'),
                meta: { title: '详情页面', icon: '' },
                hidden: false,
            },
            //客户管理-客户信息
            {
                path: '/home/customer-management/information/information',
                component: () =>
                    import ('@views/customer-management/information/information'),
                meta: { title: '客户信息', icon: '' },
                hidden: false,
            },
            //客户管理-黑白名单
            {
                path: '/home/customer-management/black-white-list/black-white-list',
                component: () =>
                    import ('@views/customer-management/black-white-list/black-white-list'),
                meta: { title: '黑白灰名单', icon: '' },
                hidden: false,
            },
            //客户管理-签署协议
            {
                path: '/home/customer-management/sign-agreement/sign-agreement',
                component: () =>
                    import ('@views/customer-management/sign-agreement/sign-agreement'),
                meta: { title: '签署协议', icon: '' },
                hidden: false,
            },
            //客户管理-客户权益
            {
                path: '/home/customer-management/equity/equity',
                component: () =>
                    import ('@views/customer-management/equity/equity'),
                meta: { title: '客户权益', icon: '' },
                hidden: false,
            },
            //客户管理-企业管理
            {
                path: '/home/customer-management/business-management/business-management',
                component: () =>
                    import ('@views/customer-management/business-management/business-management'),
                meta: { title: '企业管理', icon: '' },
                hidden: false,
            },
            //客户管理-健康档案
            {
                path: '/home/customer-management/health-records/health-records',
                component: () =>
                    import ('@views/customer-management/health-records/health-records'),
                meta: { title: '健康档案', icon: '' },
                hidden: false,
            },
            //客户管理-健康档案(详情)
            {
                path: '/home/customer-management/health-records/pages/details',
                component: () =>
                    import ('@views/customer-management/health-records/pages/details'),
                meta: { title: '健康档案', icon: '' },
                hidden: false,
            },
            //商品管理-商品信息管理
            {
                path: '/home/commodity-management/information/information',
                component: () =>
                    import ('@views/commodity-management/information/information'),
                meta: { title: '商品信息管理', icon: '' },
                hidden: false,
            },
            //商品管理-服务网点管理
            {
                path: '/home/commodity-management/service-network/service-network',
                component: () =>
                    import ('@views/commodity-management/service-network/service-network'),
                meta: { title: '服务网点管理', icon: '' },
                hidden: false,
            },
            //商品管理-实体卡管理
            {
                path: '/home/commodity-management/physical-card-management/physical-card-management',
                component: () =>
                    import('@views/commodity-management/physical-card-management/physical-card-management'),
                meta: { title: '实体卡管理', icon: '' },
            },
            //商品管理-实体卡信息
            {
                path: '/home/commodity-management/phy-card-info/phy-card-info',
                component: () =>
                    import ('@views/commodity-management/phy-card-info/phy-card-info'),
                meta: { title: '实体卡信息', icon: '' },
                hidden: false,
            },
            //订单管理-客户订单
            {
                path: '/home/order-management/customer-orders/customer-orders',
                component: () =>
                    import ('@views/order-management/customer-orders/customer-orders'),
                meta: { title: '客户订单', icon: '' },
                hidden: false,
            },
            //订单管理-客户订单-操作
            {
                path: '/home/order-management/customer-orders/pages/operate',
                component: () =>
                    import ('@views/order-management/customer-orders/pages/operate'),
                meta: { title: '客户订单', icon: '' },
                hidden: false,
            },
            //账户管理-交易对账
            {
                path: '/home/account-management/transaction-record/transaction-record',
                component: () =>
                    import ('@views/account-management/transaction-record/transaction-record'),
                meta: { title: '交易对账', icon: '' },
                hidden: false,
            },
            //账户管理-交易对账-手工对账
            {
                path: '/home/account-management/transaction-record/pages/bill',
                component: () =>
                    import ('@views/account-management/transaction-record/pages/bill'),
                meta: { title: '交易对账', icon: '' },
                hidden: false,
            },
            //账户管理-退费管理
            {
                path: '/home/account-management/refund-management/refund-management',
                component: () =>
                    import ('@views/account-management/refund-management/refund-management'),
                meta: { title: '退费管理', icon: '' },
                hidden: false,
            },
            //账户管理-退费管理-操作            
            {
                path: '/home/account-management/refund-management/pages/operate',
                component: () =>
                    import ('@views/account-management/refund-management/pages/operate'),
                meta: { title: '交易对账', icon: '' },
                hidden: false,
            },
             //账户管理-账户管理
             {
                path: '/home/account-management/account-info/account-info',
                component: () =>
                    import ('@views/account-management/account-info/account-info'),
                meta: { title: '账户管理', icon: '' },
                hidden: false,
            },
            //参数配置-订单设置
            {
                path: '/home/parameter-configuration/order-settings/order-settings',
                component: () =>
                    import ('@views/parameter-configuration/order-settings/order-settings'),
                meta: { title: '退费管理', icon: '' },
                hidden: false,
            },
            //参数配置-小程序首页菜单配置
            {
                path: '/home/parameter-configuration/app-settings/app-settings',
                component: () =>
                    import ('@views/parameter-configuration/app-settings/app-settings'),
                meta: { title: '退费管理', icon: '' },
                hidden: false,
            },{
                path: '/home/parameter-configuration/label-settings/label-settings',
                component: () =>
                    import ('@views/parameter-configuration/label-settings/label-settings'),
                meta: { title: '标签管理', icon: '' },
                hidden: false,
            },{
                path: '/home/customer-management/member/member',
                component: () =>
                    import ('@views/customer-management/member/member'),
                meta: { title: '会员管理', icon: '' },
                hidden: false,
            },
             //会员管理-查看
            {
                path: '/home/customer-management/member/pages/remind-details',
                component: () =>
                    import ('@views/customer-management/member/pages/remind-details.vue'),
                meta: { title: '查看页面', icon: '' },
                hidden: false,
            },
            {
                path: '/home/service-management/package/package',
                component: () =>
                    import ('@views/service-management/package/package'),
                meta: { title: '套餐管理', icon: '' },
                hidden: false,
            },
            //套餐管理-详情
            {
                path: '/home/service-management/package/pages/details',
                component: () =>
                    import ('@views/service-management/package/pages/details'),
                meta: { title: '详情页面', icon: '' },
                hidden: false,
            },
              {
                path: '/home/customer-management/gift-benefits/gift-benefits',
                component: () =>
                    import ('@views/customer-management/gift-benefits/gift-benefits'),
                meta: { title: '权益商品赠予', icon: '' },
                hidden: false,
            },
            //客户管理-权益商品赠予-详情页面
            {
                path: '/home/customer-management/gift-benefits/pages/operate',
                component: () =>
                    import ('@views/customer-management/gift-benefits/pages/operate'),
                meta: { title: '权益商品赠予详情', icon: '' },
                hidden: false,
            },
            {
                path: '/home/customer-management/feed-back/feed-back',
                component: () =>
                    import ('@views/customer-management/feed-back/feed-back'),
                meta: { title: '意见反馈', icon: '' },
                hidden: false,
            },
            {
                path: '/home/customer-management/feed-back/pages/details',
                component: () =>
                    import ('@views/customer-management/feed-back/pages/details'),
                meta: { title: '意见反馈详情', icon: '' },
                hidden: false,
            },
        ]
    }
];
const router = new Router({
    base: '/zs-small-web',
    mode: 'history', //新增
    routes
});



// 解决同一路由多次跳转的报错问题
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => {
        return err;
    });
};

// import { getToken,getRouter} from '@/utils/auth'
const whiteList = ['/login', '/demo', '/demo2']
router.beforeEach((to, from, next) => {
    // if (getToken()) {
    // if (to.path === '/login') {
    //     next()
    // }else {
    //     next() 
    // }
    // } else {
    // // 没有token
    // if (whiteList.indexOf(to.path) !== -1) {
    //     // 在免登录白名单，直接进入
    //     next()
    //   } else {
    //     next(`/login?redirect=${to.fullPath}`) // 否则全部重定向到登录页
    //   }
    // }
    next();
});
export default router